module.exports = __webpack_public_path__ + "media/images/promo/bg_card_4-ecb187094f7a38b95c1ac1ed1097d0f6.jpg";